import ViewQuizSubmissionLayout from 'components/ViewQuizSubmission/ViewQuizSubmissionLayout';

const Tablet = (props) => <ViewQuizSubmissionLayout device={'tablet'} {...props} />;

export default Tablet;
